import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ET_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#ET_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ET_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ET_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 18a6 6 0 100-12 6 6 0 000 12z",
      fill: "#2B77B8"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M16 14l-2.762.927.86-2.309-1.873-2.236h2.6L16 8l1.176 2.382h2.657l-1.93 2.236.685 2.309L16 14z",
      stroke: "#FECA00",
      strokeWidth: 1.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.696 12.034l-2.085 4.36M15.367 11.48h-4M16.121 12.838l3.91 1.804M16.967 11.874l2.83-3.098",
      stroke: "#2B77B8"
    }
  )))
);
export {
  t as default
};
